import { UUID } from '../../types';

export enum QuestionType {
  'OPEN' = 'OPEN',
  'CLOSED' = 'CLOSED',
  'SIGNATURE' = 'SIGNATURE',
  'MALFUNCTION' = 'MALFUNCTION',
}
export interface MalfunctionPointer {
  id: number;
  name: string;
}
export interface Choice {
  id: UUID;
  text: string;
  notify: boolean;
}
export interface BaseQuestion {
  id: UUID;
  text: string;
  type: QuestionType;
}
export interface ClosedQuestion extends BaseQuestion {
  type: QuestionType.CLOSED;
  choices: UUID[];
}
export interface OpenQuestion extends BaseQuestion {
  type: QuestionType.OPEN;
}

export interface SignatureQuestion extends BaseQuestion {
  type: QuestionType.SIGNATURE;
}

export interface MalfunctionQuestion extends BaseQuestion {
  type: QuestionType.MALFUNCTION;
}

export type Question =
  | ClosedQuestion
  | OpenQuestion
  | SignatureQuestion
  | MalfunctionQuestion;
export interface Questionnaire {
  title: string;
  questions: UUID[];
}
export interface AnswerFile {
  id: UUID;
  url: string;
  thumbUrl: string;
  contentType: string;
  name: string;
}
export interface BaseAnswer {
  question: UUID;
  answer: string;
  files: UUID[];
}

export interface OpenAnswer extends BaseAnswer {
  type: QuestionType.OPEN;
}

export interface SignatureAnswer extends BaseAnswer {
  type: QuestionType.SIGNATURE;
}
export interface MalfunctionAnswer extends BaseAnswer {
  type: QuestionType.MALFUNCTION;
  malfunctions: MalfunctionPointer[];
}
export interface ClosedAnswer extends BaseAnswer {
  choice: UUID;
  type: QuestionType.CLOSED;
}
export type Answer =
  | OpenAnswer
  | ClosedAnswer
  | SignatureAnswer
  | MalfunctionAnswer;

export type BaseAnswerState = Omit<BaseAnswer, 'files'> & {
  files: SelectedImage[];
};

export interface OpenAnswerState extends BaseAnswerState {
  type: QuestionType.OPEN;
}

export interface SignatureAnswerState extends BaseAnswerState {
  type: QuestionType.SIGNATURE;
}

export interface MalfunctionAnswerState extends BaseAnswerState {
  type: QuestionType.MALFUNCTION;
  malfunctions: MalfunctionPointer[];
}

export interface ClosedAnswerState extends BaseAnswerState {
  choice: UUID;
  type: QuestionType.CLOSED;
}
export type AnswerState =
  | OpenAnswerState
  | ClosedAnswerState
  | SignatureAnswerState
  | MalfunctionAnswerState;

export interface QuestionnairePayload {
  questionnaire: Questionnaire;
  questions: Question[];
  choices: Choice[];
  answers: Answer[];
  files: AnswerFile[];
}

export type QuestionnaireState = Omit<QuestionnairePayload, 'answers'> & {
  answers: BaseAnswerState[];
};

export interface QuestionnaireItem {
  id: UUID;
  payload: QuestionnaireState;
}

export type ServerResponse = QuestionnaireItem[];

export interface SelectedImage {
  file: File;
  src: string;
  questionId: UUID;
}
